import styles from './style.postcss';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Button, TextArea, Icon, testClass } from 'omni-common-ui';
import is from 'is_js';

class RejectNotePopup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { note: null };
    this._updateNote = this._updateNote.bind(this);
    this._onSaveClicked = this._onSaveClicked.bind(this);
  }

  _updateNote(e) {
    this.setState({ note: e.target.value });
  }

  _onSaveClicked() {
    this.props.onSave(this.state.note);
  }

  _isNoteEmpty() {
    if (is.not.string(this.state.note)) {
      return true;
    }

    return is.empty(this.state.note.trim());
  }

  render() {
    const { isOpen, isLoading } = this.props;
    return (
      <Dialog isOpen={isOpen} isLoading={isLoading} className={styles.RejectNotePopup} paddingless>
        <div className={styles.RejectNotePopup_title}>
          <span className={styles.RejectNotePopup_title_text}>Reject Notes</span>
        </div>
        <div className={styles.RejectNotePopup_content}>
          <TextArea value={this.state.note} onChange={this._updateNote} maxLength={1000} />
          <div className={styles.RejectNotePopup_content_info}>
            <Icon id="info" className={styles.RejectNotePopup_content_info_icon} />
            <span>This note will not be published to EF Parents.</span>
          </div>
          <Button.Container className={styles.RejectNotePopup_buttons}>
            <Button className={testClass('button-save')}
                type={Button.Type.primary}
                onClick={this._onSaveClicked}
                disabled={this._isNoteEmpty() || isLoading}>
              Save & Reject
            </Button>
            <Button className={testClass('button-cancel')}
                onClick={this.props.onCancel}
                disabled={isLoading} >
              Cancel
            </Button>
          </Button.Container>
        </div>
      </Dialog>
    );
  }
}

RejectNotePopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
};

export default RejectNotePopup;



// WEBPACK FOOTER //
// ./components/RejectNotePopup/index.jsx